import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByField',
  // standalone: false <--- Importante si lo vas a declarar en un NgModule
})
export class FilterByFieldPipe implements PipeTransform {
  /**
   * @param items Arreglo a filtrar
   * @param field Nombre de la propiedad (ej: 'habilitado')
   * @param value Valor esperado (ej: true)
   */
  transform(items: any[], field: string, value: any): any[] {
    if (!items || !field || value === undefined) {
      return items;
    }
    return items.filter(item => item[field] === value);
  }
}